module.exports = __webpack_public_path__ + "img/logo19.df8e6633.jpg";